import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../util/Rest';
const initialData = {
  clientData: [],
  rateHistory: [],
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  deleteRateStatus: null,
  dateValidationData: '',
  unsubScribedData: [],
  subscribedAndInactiveData: {},
  isHistoryLoading: false,
};

const slice = createSlice({
  name: 'clientRateHistory',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchHistoryStart: (state) => {
      state.isHistoryLoading = true;
      state.errorMsg = null;
    },
    getRateHistory: (state, action) => {
      state.rateHistory = action.payload;
      state.isLoading = false;
      state.isHistoryLoading = false;
      state.errorMsg = null;
    },
    getStartDateValidation: (state, action) => {
      state.dateValidationData = action.payload.response;
      // state.rateHistory = action.payload;
      // state.isLoading = false;
      // state.errorMsg = null;
    },
    getUnsubscribedData: (state, action) => {
      state.unsubScribedData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getSubscribedAndInactiveData: (state, action) => {
      state.subscribedAndInactiveData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    deleteRateData: (state, action) => {
      state.deleteRateStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ? action.payload.data.error : action.payload;
      state.isLoading = false;
      state.isHistoryLoading = false;
    },
    resetStatus: (state) => {
    //   state.communicationTimeLineStatus = null;
      state.errorMsg = null;
      state.successMsg = null;
      state.isLoading = false;
      state.deleteRateStatus = null;
    },
    resetValidationData: (state) => {
      state.dateValidationData = '';
      //   state.communicationTimeLineStatus = null;
      // state.errorMsg = null;
      // state.successMsg = null;
      // state.isLoading = false;
    },
    resetHistoryData: (state) => {
      state.rateHistory = [];
    },
  },
});

export default slice.reducer;

// Actions

export const {fetchStart, getUnsubscribedData, getSubscribedAndInactiveData, 
  resetValidationData, fetchError, resetStatus, getRateHistory, deleteRateData, getStartDateValidation, fetchHistoryStart, resetHistoryData} = slice.actions;


export const fetchRateHistoryData = (data) => {
  return (dispatch) => {
    dispatch(fetchHistoryStart());
    httpPost(`client/search/subscribeHistory/all`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getRateHistory(data?.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error && error.message ? error.message : ''));
      });
  };
};

export const deleteRate = (clientRateCardId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`client/delete/clientratecard/${clientRateCardId}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(deleteRateData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const startDateValidationApi = (data) => {
  return (dispatch) => {
    // dispatch(fetchStart());
    httpPost(`client/find/subscribedclient`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getStartDateValidation(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message)); startDateValidationApi;
      });
  };
};

export const fetchUnsubscribedServices = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`maintenance/get/all/unsubscribe`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getUnsubscribedData(data?.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error && error.message ? error.message : ''));
      });
  };
};

export const fetchSubscribedAndInactiveServices = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`maintenance/get/all/subscribe`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getSubscribedAndInactiveData(data?.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error && error.message ? error.message : ''));
      });
  };
};

export const resetStatusCode = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};

export const resetDateValidation = () => {
  return (dispatch) => {
    dispatch(resetValidationData());
  };
};
